import { Stack, useTheme } from "@mui/material";
import { Tooltip } from "components";
import { LucidePlusIcon } from "components/icons";

// "+" that appends another schedule row. Shared by the assign/escalate drawer's
// member card and the ticket header's "Assign to me" popover.
export const AddScheduleButton = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme();
  return (
    <Tooltip title="Add schedule" disableSentenceCase>
      <Stack
        alignItems="center"
        justifyContent="center"
        height="28px"
        width="28px"
        border={`1px solid ${theme.palette.neutral["005"]}`}
        borderRadius={"6px"}
        boxShadow={"0px 0px 4px 0px #0000000F, 0px 0px 2px 0px #0000000A"}
        ml="auto"
        onClick={onClick}
        aria-label="Add schedule"
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        }}
        sx={{ cursor: "pointer" }}
      >
        <LucidePlusIcon
          style={{
            width: "20px",
            height: "20px",
          }}
        />
      </Stack>
    </Tooltip>
  );
};
